class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('s-cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('[data-cart-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    document.querySelectorAll('[data-open-cart]').forEach((openButton) =>
        {
          openButton.addEventListener('click', this.open.bind(this))

        }
    );
  }

  open() {
    this.notification.classList.add('is-open');
    if (document.querySelector('.s-header__button_burger').classList.contains('is-active')) {
      document.querySelector('.s-header__button_burger').click();
    }

    if (document.querySelector('.s-header__button_search').classList.contains('is-active')) {
      document.querySelector('.s-header__button_search').click();
    }

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('is-open');

    document.body.removeEventListener('click', this.onBodyClick);
    let url = window.location.href;
    url = url.replace( window.location.search, '');
    window.history.replaceState({ }, '',  url );
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        if (section.id == 's-cart-notification') {
          document.getElementById('s-cart-notification__pane').innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              $('[data-v-scrollbar]').scrollbar();
              } else {
          document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          $('[data-color]').variantColorProduct();
        }

      }));
      if (this.header) this.header.reveal();
      this.open();
      if (document.querySelector('.c-ref-product')) {
        $('[data-toggle="ref-product"]').click(function (e) {
          e.preventDefault();
          var $tooltip = $(this).find(".c-ref-product__title__info");
          if (e.target === $tooltip[0]) return false;
          $(this).closest('.c-ref-product').toggleClass('is-open').find('.c-ref-product__body').stop().slideToggle();
        });
        $('[data-color]').variantColorProduct();
        $('[data-toggle="tooltip"]').tooltip();
        changeRefQty();
      }
  }

  getSectionsToRender() {
    return [
      {
        id: 's-cart-notification',
        selector: `.s-cart-notification__pane`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('[data-open-cart]') || target.closest('[data-cart-close]') ) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

$(document).ready(function () {
    $('[data-v-scrollbar]').scrollbar();

    $('[data-toggle="ref-product"]').not('.c-ref-product__title__info').click(function (e) {
      e.preventDefault();
      var $tooltip = $(this).find(".c-ref-product__title__info");
      if (e.target === $tooltip[0]) return false;
      $(this).closest('.c-ref-product').toggleClass('is-open').find('.c-ref-product__body').stop().slideToggle();
    });
});
